/**
 * Whether a joined-groups list page has no further API pages.
 * - `pageLength < limit`: normal final partial page.
 * - `pageLength > limit`: API ignored skip/limit and returned the full list at once.
 */
export function isTerminalGroupsListPage(pageLength: number, limit: number): boolean {
  return pageLength !== limit
}
